import * as React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { formatDate } from "@progress/kendo-intl";
import { Tile } from "components/UIComponents/Tile";
import DataList from "components/MatterDetails/DataList";
import { AmountFormat } from "components/common/formatter";
import { useAllNominals } from "services/nominalsService";
import styles from "./Posting.module.scss";

const EXPENSE_POSTING_TYPE = "EXP";

export const isExpensePostingType = (postingType) =>
  String(postingType ?? "").toUpperCase() === EXPENSE_POSTING_TYPE;

const ExpenseDetails = ({ dataItem, matterRef, cancelEdit }) => {
  const grossAmount = Math.abs(Number(dataItem?.grossAmount ?? 0));
  const vatAmount = Math.abs(Number(dataItem?.vatAmount ?? 0));
  const netAmount = grossAmount - vatAmount;

  const { data: nominals } = useAllNominals();
 
  const nominalRef = dataItem?.nominalRef;
  const nominal =
    (nominalRef
      ? nominals?.find((n) => n.nominalRef === nominalRef)?.display
      : "") || nominalRef;

  const renderRow = (text, value, minWidth = "115px", valueClass = "mb-2") => (
    <DataList
      text={text}
      value={value}
      keyClass="mb-2"
      valueClass={valueClass}
      width="w-100"
      keyStyles={{ minWidth }}
      valueStyles={{ minWidth: 0, wordBreak: "break-word" }}
    />
  );

  return (
    <Dialog title="Expense Details" onClose={cancelEdit} className="dialog-xxs">
      <Tile className="py-3 px-4 my-3 mx-4">
        <div className="w-100 mb-2">
          <span className={styles["dialog-section-heading"]}>
            {`Expense${matterRef ? ` - ${matterRef}` : ""}`}
          </span>
        </div>
        <div className="d-flex justify-content-between">
          <div style={{ width: "70%" }}>
            {renderRow(
              "Date:",
              dataItem?.date
                ? formatDate(new Date(dataItem.date), "d", "en-GB")
                : "",
            )}
            {renderRow("Nominal:", nominal)}
            {renderRow("Details:", dataItem?.details)}
          </div>
          <div style={{ width: "28%" }}>
            {renderRow("Net:", AmountFormat(netAmount), "60px", "text-end mb-2")}
            {renderRow("VAT:", AmountFormat(vatAmount), "60px", "text-end mb-2")}
            {renderRow(
              "Gross:",
              AmountFormat(grossAmount),
              "60px",
              "text-end mb-2",
            )}
          </div>
        </div>
      </Tile>
      <DialogActionsBar>
        <div className="dialog-footer w-100">
          <Button
            className="common-btn bgBtnSecondary border-0 me-3"
            onClick={cancelEdit}
          >
            Close
          </Button>
        </div>
      </DialogActionsBar>
    </Dialog>
  );
};

export default ExpenseDetails;
